import { TRUST_MARKERS } from "@/data/content";

export default function Marquee() {
  const items = [...TRUST_MARKERS, ...TRUST_MARKERS];
  return (
    <section
      data-testid="marquee-strip"
      aria-label="Trust markers"
      className="border-b border-[#E4E7EC] bg-[#101828] py-4 overflow-hidden"
    >
      <div className="marquee-track">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-mono-accent mx-8 text-[#FDB022]"
          >
            {t} <span className="ml-8 text-[#475467]">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
